import styled from 'styled-components';

import { Colors } from 'modules/ui/theme/colors';

export const Container = styled.div<{ isOpen: boolean }>`
  position: absolute;
  display: flex;
  height: 28px;
  border-radius: 4px;
  flex-direction: column;
  align-items: center;
  background-color: ${Colors.White}CC;
  flex-direction: row-reverse;
  left: ${({ isOpen }): string => (isOpen ? '-224px' : '4px')};
  width: ${({ isOpen }): string => (isOpen ? '220px' : '0px')};
  transition: width 500ms ease-in-out, left 500ms ease-in-out;
  overflow: hidden;
  > div:not(:last-child) {
    margin-left: 8px;
  }
  > div:first-child {
    margin-right: 2px;
  }
  > div:first-child {
    margin-left: 2px;
  }
`;

export const VisibleFlows = styled.div`
  visibility: visible;
`;
